import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Form, Row, Col } from 'react-bootstrap';

import { GEOJSON_GEOMETRIES, BORDER_STYLES_TYPES } from '../../../api/Styles/Styles';
import { getWeight, getBorderStyle } from '../../../api/Styles/style-operations';

import ColorPicker from '../../components/ColorPicker';

const GeometryOutlineFields = ({
  geojsonGeometry,
  style,
  updateBorderColor,
  borderAlpha,
  borderColor
}) => {
  const isLineGeometry = geojsonGeometry === GEOJSON_GEOMETRIES.LINESTRING;
  const lineName = isLineGeometry ? 'Line' : 'Outline';

  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column xs={6}>
          {`${lineName} Type`}
        </Form.Label>
        <Col xs={6}>
          <Form.Control as="select" name="lineType" defaultValue={getBorderStyle(style)}>
            {map(BORDER_STYLES_TYPES.properties, ({ name, humanValue, value }) => (
              <option value={value} key={name}>
                {humanValue}
              </option>
            ))}
          </Form.Control>
        </Col>
      </Form.Group>
      <Row>
        <Col xs={12} sm={!isLineGeometry ? 6 : 12}>
          <Form.Group as={Row}>
            <Form.Label column xs={6}>
              {`${lineName} Weight`}
            </Form.Label>
            <Col xs={6}>
              <Form.Control
                type="number"
                name="weight"
                key={`weight:${getWeight(style)}`}
                defaultValue={getWeight(style)}
                min="0"
              />
            </Col>
          </Form.Group>
        </Col>
        {!isLineGeometry && (
          <Col xs={12} sm={6}>
            <Form.Group as={Row}>
              <Form.Label column xs={6}>
                {`${lineName} Color`}
              </Form.Label>
              <Col xs={6} className="mt-2">
                <ColorPicker
                  color={borderColor}
                  alpha={borderAlpha}
                  updateColor={updateBorderColor}
                />
              </Col>
            </Form.Group>
          </Col>
        )}
      </Row>
    </>
  );
};

GeometryOutlineFields.propTypes = {
  geojsonGeometry: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  updateBorderColor: PropTypes.func.isRequired,
  borderAlpha: PropTypes.number.isRequired,
  borderColor: PropTypes.string.isRequired
};

export default GeometryOutlineFields;
